import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import * as VueGoogleMaps from "vue2-google-maps";
import VueGtag from "vue-gtag";

import {
  Layout,
  Input,
  Modal,
  message,
  Button,
  Select,
  Switch,
  Slider,
  // Button,
  // Dropdown,
  Icon,
  // Radio,
  // Divider,
  // Menu,
  // Modal,
  // Input,
  // Select,
  // FormModel,
  // Checkbox,
  // message,
  // Collapse,
  Table,
  // Carousel,
  // Popconfirm,
  // Tag,
  // Upload,
  // DatePicker,
} from "ant-design-vue";

import { Checkbox, CheckboxGroup } from "element-ui";
import config from "./config";

Vue.prototype.$success = Modal.success;
Vue.prototype.$config = config;
Vue.prototype.$message = message;

// antd
Vue.use(Layout);
Vue.use(Select);

if (process.env.VUE_APP_GA_TRACKING_ID !== undefined) {
  Vue.use(VueGtag, {
    config: { id: process.env.VUE_APP_GA_TRACKING_ID },
  });
}
Vue.component(Input.name, Input);
Vue.component(Modal.name, Modal);
Vue.component(Button.name, Button);
Vue.component(Icon.name, Icon);
Vue.component(Table.name, Table);
Vue.component(Switch.name, Switch);
Vue.component(Slider.name, Slider);

// element-ui
Vue.component(CheckboxGroup.name, CheckboxGroup);
Vue.component(Checkbox.name, Checkbox);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCPWHLuYhHw3pba2LzjIYifbUaIahFVe0E",
    libraries: "places,drawing",
    region: "jp",
    language: "jp",
  },
  installComponents: true,
});

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
  beforeCreate() {
    Vue.prototype.$bus = this;
  },
}).$mount("#app");
